import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
     body {
        font-family: 'DM Sans', sans-serif;
        overflow: hidden;
        width: 100vw;
        background-color: #fafafb;
    }
    p,h1,h2,h3,h4,h5,h6{
        padding: 0;
        margin: 0;
    }

`;
